import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Sparkles.svg'

export const IconSparkles = IconSVG as IconComponent
